import { Carousel } from "./carousel";

customElements.define("uwp-carousel", Carousel);
